import React from "react";
import { Link } from "react-router-dom";
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { FaBars } from 'react-icons/fa';
import "./BreadcrumbComponents.css";
import Header from "../Header";

const BreadcrumbComponents = (props) => {
    let { routes, onMenuClick } = props;
    const breadcrumbs = useBreadcrumbs(routes);

    return (
        <div className="main-nav-container">
            <div className="breadcrumbs-left">
                {/* Hamburger — visible only on mobile */}
                <button className="hamburger-btn" onClick={onMenuClick} aria-label="Open menu">
                    <FaBars />
                </button>
                <nav className="breadcrumbs-nav">
                    {breadcrumbs.map(({ breadcrumb, match }, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span key={match.pathname}>
                                {!isLast ? (
                                    <>
                                        <Link to={match.pathname} className="breadcrumb-link">
                                            {typeof breadcrumb === 'function' ? React.createElement(breadcrumb) : breadcrumb}
                                        </Link>
                                        <span className="breadcrumb-separator">/</span>
                                    </>
                                ) : (
                                    <span className="breadcrumb-current">{breadcrumb}</span>
                                )}
                            </span>
                        );
                    })}
                </nav>
            </div>

            <div className="breadcrumbs-right">
                <Header />
            </div>
        </div>
    );
};

export default BreadcrumbComponents;
